export enum SelectedBrandkitActions {
  SET_SELECTED_BRANDKIT = "SET_SELECTED_BRANDKIT",
  UPDATE_SELECTED_BRANDKIT = "UPDATE_SELECTED_BRANDKIT",
  DELETE_SELECTED_BRANDKIT = "DELETE_SELECTED_BRANDKIT",
}
